<template>
	<div class="details-container">
		<div class="backBox" @click="handleClose">
			<img class="backIcon" src="../assets/Personal/iconI.png" />
			返回
		</div>
		<div class="activityInfoBox">
			<div class="activityInfos">
				<!-- <img class="activityImage" :src="details.img" /> -->
				<div class="swiper-container">
					<div class="swiper-wrapper" v-if="banner.length && banner.length > 1">
						<div class="swiper-slide" v-for="(item,index) in banner" :key="index">
							<video controls style="width: 100%; height: 3rem;" @play="onplay" @playing="onPlaying"
								@pause="onPause" @ended="onEnded" :src="item.url" v-if="item.type == 'video'"></video>
							<el-image class="carousel-image" fit="cover" :src="item.url"
								:preview-src-list="details.banner" v-if="item.type == 'img'">
							</el-image>
						</div>
					</div>
					<div class="swiper-wrapper" v-if="banner.length && banner.length == 1">
						<div class="swiper-slide">
							<el-image class="carousel-image" fit="cover" :src="banner[0].url"
								:preview-src-list="details.banner">
							</el-image>
						</div>
					</div>
					<!-- <div class="swiper-pagination"></div> -->
				</div>
				<div class="activityInfo">
					<div class="activityTitle ellipsis-1">{{details.title ? details.title : '' }}</div>
					<div class="activityDesc ellipsis-3">{{details.content ? details.content : ''}}</div>
					<div class="tiemBox">
						<div class="activityTime"> <span>活动时间：</span>{{details.action_time}} — {{details.end_time}}
						</div>
						<div class="activityEndTime"><span>报名截止：</span>{{details.last_time}}</div>
						<div class="activityPublishTime"><span>发布时间：</span>{{details.create_time}}</div>
					</div>
					<div class="signUp" :class="details.status == '进行中' ? (joined ? 'normal' : 'active') : 'normal'"
						@click="signUpActivity">
						{{details.status == '进行中' ? (joined ? '已报名' : '立即报名') : details.status == '未开始' ? '未开始' :'已截止'}}
					</div>
				</div>
			</div>
		</div>
		<div class="detail">
			<div class="subTilte">
				活动详情
			</div>
			<div class="rihText" v-html="details.details">
			</div>
		</div>
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body>
			<div slot="title">
				<div class="dislogTitle">
					立即报名
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="姓名：" prop="name">
						<el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="备注：" prop="content">
						<div class="reportContent">
							<el-input v-model="ruleForm.content" type="textarea" maxlength="200" placeholder="请输备注" />
							<div class="textNum">
								<span>{{ruleForm.content ? ruleForm.content.length : 0}}</span>/200
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'您已成功提交，请耐心等待!'"
			@clickOk="sucPop = false" v-if="sucPop" />
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import PopToast from '../components/PopToast.vue'
	export default {
		name: 'MyActivityDetails',
		components: {
			PopToast,
		},
		props: {
			goods: {
				type: Object,
				default: () => {}
			}
		},
		watch: {
			goods: {
				handler(newValue) {
					console.log(newValue)
					this.activityDetails()
					this.activityIn()
				},
				deep: true
			}
		},
		data() {
			return {
				swiper: null,
				banner: [],
				dialogReportVisible: false,
				sucPop: false,
				details: {},
				joined: false,
				ruleForm: {
					name: '',
					content: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			onplay() {
				this.swiper.allowTouchMove = false;
				this.swiper.autoplay.stop();
			},
			onPlaying() {
				this.swiper.allowTouchMove = false;
				this.swiper.autoplay.stop();
			},
			onPause() {
				this.swiper.allowTouchMove = true;
				this.swiper.autoplay.start();
			},
			onEnded() {
				this.swiper.allowTouchMove = true;
				this.swiper.autoplay.start();
			},
			initSwiper() {
				// 创建Swiper实例
				this.swiper = new Swiper('.swiper-container', {
					// 轮播图选项
					slidesPerView: 1,
					loop: true,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false
					},
					// 分页设置
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
						// 方形指示器样式
						renderBullet: function(index, className) {
							return '<span class="' + className + '"></span>';
						}
					}
				})
			},
			activityDetails() {
				this.$api.post('/Activity/activity_details', {
					id: this.goods.aid,
				}).then(res => {
					if (res.code == 1) {
						this.banner = []
						this.details = res.data
						if (this.details.video) {
							this.banner.push({
								url: this.details.video,
								type: 'video'
							})
						}
						this.details.banner.forEach(item => {
							this.banner.push({
								url: item,
								type: 'img'
							})
						})
						if (this.banner.length > 1) {
							this.$nextTick(() => {
								this.initSwiper()
							})
						}
						this.details.details = this.formatRichText(this.details.details)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			activityIn() {
				this.$api.post('/release/activity_in', {
					aid: this.goods.aid,
				}).then(res => {
					if (res.code == 1) {
						this.joined = false
					} else {
						if (res.data == 1) {
							this.joined = true
						}
					}
				}).catch(err => {
					console.log(err);
				})
			},
			signUpActivity() {
				if (this.details.status == '已截止' || this.details.status == '未开始' || this.joined) return
				if (localStorage.getItem('token')) {
					this.dialogReportVisible = true
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Release/activity_join', {
							aid: this.goods.aid,
							name: this.ruleForm.name,
							content: this.ruleForm.content
						}).then(res => {
							if (res.code == 1) {
								this.dialogReportVisible = false
								this.activityDetails()
								this.activityIn()
								this.sucPop = true
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			formatRichText(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					match = match.replace(/style=""/gi, '').replace(/style=''/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match) {
					match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi,
						'width:100%;');
					return match;
				});
				newContent = newContent.replace(/<img/gi,
					'<img style="width:100%;height:auto;display:block;margin:0px 0;"');

				return newContent;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.details-container {
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		padding: .24rem .4rem;
	}

	.backBox {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
		cursor: pointer;

		.backIcon {
			width: .06rem;
			height: .1rem;
			margin-right: .06rem;
		}
	}

	.activityInfoBox {
		width: 100%;
		background: #FFFFFF;

		.activityInfos {
			margin: .32rem auto 0;
			display: flex;
			align-items: flex-start;

			.activityImage {
				width: 4.26rem;
				height: 2.16rem;
				border-radius: .08rem;
				object-fit: cover;
				overflow: hidden;
			}

			.activityInfo {
				margin-left: .24rem;
				width: 4.25rem;
				display: flex;
				flex-direction: column;

				.activityTitle {
					font-weight: 500;
					font-size: .24rem;
					color: #693200;
					line-height: .36rem;
				}

				.activityDesc {
					width: 4.25rem;
					font-size: .14rem;
					color: #333333;
					line-height: .2rem;
				}

				.tiemBox {
					margin-top: .12rem;
					display: flex;
					flex-direction: column;

					.activityTime,
					.activityEndTime,
					.activityPublishTime {
						font-weight: 400;
						font-size: .14rem;
						color: #999999;
						line-height: .22rem;
					}
				}

				.signUp {
					margin-top: .24rem;
					width: 2.60rem;
					height: .52rem;
					border-radius: .06rem;
					font-weight: 500;
					font-size: .16rem;
					color: #252525;
					text-align: center;
					line-height: .52rem;
					cursor: pointer;
				}

				.active {
					background: #E29358;
				}

				.normal {
					background: #CCCCCC;
				}
			}
		}
	}

	.detail {
		margin: .32rem auto .9rem;
		width: 12rem;

		.subTilte {
			margin: 0 0 .2rem;
			font-weight: 500;
			font-size: .18rem;
			color: #000000;
			line-height: .26rem;
		}
	}


	.reportDialog {

		::v-deep .el-dialog {
			width: 7.40rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.reportContent {
					position: relative;

					.textNum {
						position: absolute;
						right: .12rem;
						bottom: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #999999;
						line-height: .2rem;

						span {
							color: #252525;
						}
					}
				}

				.el-form {

					&-item:nth-child(2) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__content {

							.el-textarea {
								&__inner {
									width: 6rem;
									height: 1.6rem;
									background: #FFFFFF;
									border-radius: .04rem;
									border: .01rem solid #EFD8B8;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
					}
				}
			}
		}
	}
</style>